import { isFranceMode } from '@/utils/france-mode'

/**
 * React hook wrapper around {@link isFranceMode} (env-driven, so no React state needed). Use in
 * components to hide France-only legal/regulatory UI for customers outside France.
 */
export function useIsFranceMode(): boolean {
  return isFranceMode()
}
